export const qcReports = {
  locationName: "/manage-issue-/-request",
  menuName: "Manage Issue/Request",
  noRecordsFound: "No records found",
  title:"QC Reports",
  projectName:"lease operator",
  roleName:"jato",
  lessThan:"less",
  greaterThan:"greater",
  equal:"equal"
};
export const statusCode={
  success:200,
  notFound:404
}
export const project={
  OEM:"OEMS",
  LO:"LEASE OPERATOR",
  BO:"BUSINESS OFFER",
  TA:"TRANSACTIONAL ANALYSIS"
}
export const label={
  oemProvider:"OEM Provider",
  leasingProvidder:"Leasing Provider"
}